/* eslint-disable */
import React, { useState, useEffect, useRef, useContext } from 'react'
import classNames from 'classnames'
import { Spacer, Button, Checkbox } from '@cleartrip/bento'

import { isEmpty } from 'AccountsUtils'
import { sendClevertapUIActionEvent as ClevertapEvent } from 'AccountsUtils'
import { resolveKeysInObjectsArrays } from 'AccountsUtils'
import OfflineToast from '../offlineToast'

import {
  verifyOtpForSignIn,
  sendOtpForSignIn
} from '../../../pages/Trips/trips.helper'
import { errorConfig } from './errorConfig'
import OtpBox from './otpBox'
import USER_PROFILE_PAGE_CONTANTS from '../UserProfileConstants'

import Toast from 'Lib/Toast'
import { invokeCustomEvent } from '../../../utils/index'

const verifyMobileNumberML = ({
  isPwa,
  mobileNumber,
  defaultCountryCode,
  setPageName,
  email,
  setMobileNumber,
  userDetail,
  setIsGOpaque = () => { },
  setIsPOpaque = () => { },
  setIsNumberEditable = () => { },
  setIsEOpaque = () => { },
  setUserDetail = () => { },
  setToastMessagex = () => { }
}) => {
  const animationDefaultState = {
    isAnimate: false,
    direction: 'right',
    isFadeIn: false
  }

  const refs = [useRef(), useRef(), useRef(), useRef(), useRef(), useRef()]

  const [otpDigits, setOtpDigits] = useState(['', '', '', '', '', ''])
  const [otpValidationError, setOtpValidationError] = useState('')
  const [apiError, setApiError] = useState('')
  const [countDown, setCountDown] = useState(30)
  const [retriesLeft, setRetriesLeft] = useState(4)
  const [animationParams, setAnimationParams] = useState(animationDefaultState)
  const [isLoading, setIsLoading] = useState(false)
  const [elementInFocus, setElemntInFocus] = useState(0)
  const [isMobVisible, setIsMobVisible] = useState(false)
  //const [isMobVisible, setIse] = useState(false)

  const animatedClass = classNames({
    'slide-in-right':
      animationParams.direction === 'right' && animationParams.isAnimate,
    'slide-in-left':
      animationParams.direction === 'left' && animationParams.isAnimate,
    'px-0': 'px-0'
  })

  const getOtpValue = () => {
    const otp = otpDigits.join('')
    return otp
  }
  const [isSticky, setSticky] = useState(true)
  const [vheight, setVheight] = useState(window.innerHeight)

  const loginContainer = useRef(null)

  const errorInfo = 'fs-inherit c-inherit pl-2'
  const disabled = getOtpValue().length != 6
  const query = resolveKeysInObjectsArrays(['location', 'pathname'], window)
  const pathname = query.split('/')
  const pagePath = pathname[2]
  useEffect(() => {
    refs[0] && refs[0].current && refs[0].current.focus()
    countDownHandler(30)
  }, [])

  const setElementInFocus = index => {
    setElemntInFocus(index)

    refs[index] && refs[index].current && refs[index].current.focus()
  }
  // useEffect(() => {
  //   const bannerTimer = setTimeout(() => {
  //     setIsMobVisible(false)
  //   }, 2000)
  //   return () => {
  //     clearTimeout(bannerTimer)
  //   }
  // }, [isMobVisible])

  const countDownHandler = (countDown, lastCountdown = false) => {
    if (countDown === 0) {
      return
    }
    if (countDown === 1) {
      if (lastCountdown) {
        setRetriesLeft(-1)
      }
    }
    const updatedCountDown = countDown - 1
    setCountDown(updatedCountDown)
    setTimeout(() => countDownHandler(updatedCountDown, lastCountdown), 1000)
  }

  const clearOtp = () => {
    const emptyOtpDigits = ['', '', '', '', '', '']
    setOtpDigits(emptyOtpDigits)

    refs[0] && refs[0].current && refs[0].current.focus()
  }
  const resendOtp = async () => {
    if (countDown !== 0 || retriesLeft <= 0) {
    } else {
      setApiError('')
      setOtpValidationError(false)
      try {
        const payload = {
          type: 'MOBILE',
          value: mobileNumber,
          countryCode: defaultCountryCode,
          action: 'UPDATE_MOBILE'
        }
        const response = await sendOtpForSignIn(payload)
        const { status, data, error } = response || {}
        if (status === 202) {
          const { action } = data || {}
          clearOtp()
          countDownHandler(30)
        } else {
          const { response = { data: {} } } = error || {}
          const { data = {} } = response
          const { message } = data
          const err = errorConfig[message] || errorConfig.default
          if (isEmpty(email)) {
          }
          setApiError(err)
          if (message === 'OTP_SEND_LIMIT_EXCEEDED') {
            setRetriesLeft(-1)
          }
        }
      } catch (e) {
        setApiError('Something went wrong')
        console.log('Resend api error', e)
      }
    }
  }

  const otpChangeHandler = (event, index) => {
    setOtpValidationError(false)
    setApiError('')
    const value = event.nativeEvent.data || event.target.value
    const numberValue = Number(value)
    if (value === ' ') return
    if (value === '') {
      const otpFieldValues = [...otpDigits]
      otpFieldValues[index] = ''
      setOtpDigits(otpFieldValues)
      return
    }
    if (numberValue >= 0 && Number.isInteger(numberValue)) {
      const otpFieldValues = [...otpDigits]
      otpFieldValues[index] = value % 10
      setOtpDigits(otpFieldValues)
      setElementInFocus(index + 1)
    }
  }
  const otpCursorHandler = (event, index) => {
    if (event.keyCode === 37) {
      setElementInFocus(index - 1)
    }
    if (event.keyCode === 39) {
      setElementInFocus(index + 1)
    }
    if (event.keyCode === 8) {
      if (event.target.value === '') {
        const otpFieldValues = [...otpDigits]
        const indexToRemove = index - 1
        if (indexToRemove < 0) {
          return
        }
        otpFieldValues[indexToRemove] = ''
        setOtpDigits(otpFieldValues)
        setElementInFocus(indexToRemove)
      } else {
        const otpFieldValues = [...otpDigits]
        otpFieldValues[index] = ''
        setOtpDigits(otpFieldValues)
      }
    }
  }

  const handleCancel = () => {
    setIsNumberEditable(true)

    setIsGOpaque(false)
    setIsPOpaque(false)
    setIsEOpaque(false)
  }
  const verifyOtp = async () => {
    setIsLoading(true)
    const otp = getOtpValue()
    const payload = {
      type: 'MOBILE',
      value: mobileNumber,
      countryCode: defaultCountryCode,
      action: 'UPDATE_MOBILE',
      otp
    }

    setIsMobVisible(true)
    try {
      const response = await verifyOtpForSignIn(payload)
      const { status, data, error } = response || {}
      if (status === 200) {
        invokeCustomEvent('CLEVERTAP_PROFILE', { type: 'profileUpdate' })
        ClevertapEvent({
          action_name: 'mobile_number_updated_message',
          page_name: 'profile',
          platform: 'Desktop',
          is_logged_in: 'Yes',
          domainName: window && window.location.hostname
        })

        userDetail
        const { action } = data || {}
        setUserDetail({ ...userDetail, mobile: mobileNumber })
        setApiError('')
        setToastMessagex('Mobile number has been updated')
        setIsNumberEditable(true)
        setIsGOpaque(false)
        setIsPOpaque(false)
        setIsEOpaque(false)
      } else {
        const { response = { data: {} } } = error || {}
        const { data = {} } = response
        const { message } = data
        const errRes = errorConfig[message] || errorConfig.default
        if (message === 'INVALID_OTP') {
          ClevertapEvent({
            action_name: 'invalid_otp_message',
            page_name: 'profile',
            platform: 'Desktop',
            is_logged_in: 'Yes',
            domainName: window && window.location.hostname
          })
          setOtpValidationError(errRes)
        } else if (
          message === 'ID_ALREADY_VERIFIED_WITH_SAME_DETAILS_AND_TYPE' ||
          message === 'USER_ALREADY_EXISTS_FOR_MOBILE'
        ) {
          setApiError(errRes)
          ClevertapEvent({
            action_name: 'mobile_number_exists_message',
            page_name: 'profile',
            platform: 'Desktop',
            is_logged_in: 'Yes',
            domainName: window && window.location.hostname
          })
        } else {
          setApiError(errRes)
        }
      }
    } catch (e) {
      setApiError('Something went wrong')
    }
    setIsLoading(false)
  }

  const otpBlock = [1, 2, 3, 4, 5, 6].map((element, index) => {
    return (
      <OtpBox
        key={index}
        onKeyDown={e => otpCursorHandler(e, index)}
        onChange={e => otpChangeHandler(e, index)}
        onMouseDownCapture={() => {
          setElementInFocus(index)
        }}
        ref={refs[index]}
        value={otpDigits[index]}
        style={{
          margin: `11px ${index === 5 ? '0px' : '10px'} 14px 0px`,
          border: otpValidationError
            ? ' solid 1px #ff3c2b'
            : refs[index] && refs[index].current === document.activeElement
              ? 'solid 1px #36c'
              : 'solid 1px #e6e6e6'
        }}
      />
    )
  })

  return (
    <div
      className={`${isSticky ? 't-0 bg-white' : 'b-0 flex-between '} 
    ${isPwa
          ? 'flex flex-column overflow-y-scroll z-2 w-100p p-fixed'
          : ' d-flex'
        } 
  
        `}
      style={{
        background: isPwa ? '#00000080' : '#ffffff',
        height: isPwa ? vheight : 'auto'
      }}
    >
      <div
        onKeyDown={e => {
          if (e.key === 'Enter') {
            if (!disabled) {
              verifyOtp()
            }
          }
        }}
        style={{
          width: isPwa ? 'auto' : '416px',
          height: '437px'
        }}
        className={`${animatedClass} d-flex flex-1 flex-column bg-white`}
      >
        <div className="fw-600 fs-4">Verify Your Number</div>

        <OfflineToast
          page={isEmpty(email) ? 'proceed' : 'verify mobile number'}
        />

        <div className="d-flex flex-column  flex-1">
          <div>
            <div
              className={`c-pointer flex flex-middle ${isLoading ? 'c-neutral-200' : 'c-secondary-500'
                } fs-3 fw-500`}
            />
            <Spacer className="pt-6" />
            <p className="fs-3 c-neutral-700 flex flex-row">
              <span className="fs-3 c-neutral-700">
                {' '}
                {'Enter the OTP sent to'}{' '}
              </span>
              <span className="fs-3 c-neutral-700 fw-600">{`${defaultCountryCode} ${mobileNumber}`}</span>
              <span
                style={{
                  marginTop: '1px',
                  marginLeft: '5px',
                  verticalAlign: 'middle',
                  color: '#3366CC'
                }}
                className="fs-2 fw-500"
                onClick={() => {
                  setPageName(USER_PROFILE_PAGE_CONTANTS.SIGNINML)
                }}
              >
                {'Change'}
              </span>
            </p>
            <div className="d-flex">{otpBlock}</div>
            {otpValidationError && (
              <div className="c-error-500 mb-3" style={{ marginTop: '-8px' }}>
                {otpValidationError}
              </div>
            )}
            {apiError && (
              <div
                className="fw-500 fs-12 lh-16 mb-2"
                style={{ color: '#CC1414' }}
              >
                {apiError}
              </div>
            )}
            <div style={{ marginBottom: '29px' }} className="flex flex-row">
              <span className="fs-2 c-neutral-700">Haven't received OTP?</span>
              <div ref={loginContainer} />

              <span
                onClick={resendOtp}
                className={`fs-2 fw-500 ml-1 ${retriesLeft === -1
                  ? 'c-neutral-200'
                  : countDown !== 0
                    ? 'c-neutral-200'
                    : isLoading
                      ? 'c-neutral-200'
                      : 'c-blue c-pointer'
                  }`}
              >
                {retriesLeft === -1
                  ? 'Resend'
                  : countDown !== 0
                    ? `Resend (${countDown}s)`
                    : 'Resend'}
              </span>
            </div>
          </div>

          <div className="flex flex-row">
            <Button
              className="h-10 w-160 br-6-imp"
              disabled={disabled}
              size="lg"
              type="secondary"
              busy={isLoading}
              onClick={() => verifyOtp()}
            >
              <span className={`${disabled ? 'c-grey-30' : ''} fs-3 fw-500 `}>
                Verify OTP
              </span>
            </Button>
            <a
              onClick={() => handleCancel()}
              className="fw-600 fs-14 lh-20 ml-12 mt-2"
            >
              Cancel
            </a>
          </div>
        </div>
      </div>
    </div>
  )
}

export default verifyMobileNumberML
